import * as React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import './index.css';
import 'assets/fonts/fonts.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
